import { TranslatedText } from "@/components/common/text";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const LoadboardTimestamps = ({ createdAt, updatedAt }) => {
    return (
        <div className="w-full flex justify-end items-center gap-4 text-cm-p-text-secondary text-xs/[19px] mt-4">
            <span>
                <TranslatedText>Created on</TranslatedText> {dayjs(createdAt).format("MMM D, YYYY [at] h:mm A")}
            </span>
            {createdAt !== updatedAt ? (
                <span>
                    <TranslatedText>Last updated</TranslatedText> {dayjs(updatedAt).fromNow()}
                </span>
            ) : null}
        </div>
    );
};
